import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

type THeaderItem = {
  label: string;
  value: string;
};

export type TEditItem = {
  id?: string;
  name: string;
  deletable?: boolean;
  isReadOnly?: boolean;
};

export type TEditableListDismissEmitVal = {
  role: undefined;
  data?: {
    updatedEditList: TEditItem[];
  };
};

@Component({
  selector: 'monorepo-editable-list',
  templateUrl: './editable-list.component.html',
  styleUrls: ['./editable-list.component.scss'],
})
export class EditableListComponent implements OnInit, OnChanges {
  @Input() action: 'EDIT' | 'ADD' | 'VIEW' = 'VIEW';
  @Input() title: string = '';
  @Input() subtitle: string = '';
  @Input() header: THeaderItem[] = [];
  @Input() editList: TEditItem[] = [];
  @Input() defaultListLength: number = 5;
  @Input() updatedEditList: TEditItem[] = [];

  isViewOnly: boolean = false;

  constructor(private modalController: ModalController) {}

  ngOnInit(): void {
    this.initialize();
  }

  ngOnChanges(): void {
    this.initialize();
  }

  initialize() {
    this.isViewOnly = this.action === 'VIEW';
    if (this.editList.length < this.defaultListLength) {
      const additionalRows = Array(this.defaultListLength - this.editList.length).fill('');
      const entireList = this.action === 'VIEW' ? this.editList : this.editList.concat(additionalRows);
      this.initializeUpdatedEditList(entireList);
    } else {
      this.initializeUpdatedEditList(this.editList);
    }
  }

  initializeUpdatedEditList(editList: TEditItem[]) {
    this.updatedEditList = editList.map((editItem, index) => {
      return {
        id: editItem.id,
        name: editItem.name,
        deletable: editItem.deletable,
        isReadOnly: editItem.isReadOnly,
      };
    });
  }

  dimissModal() {
    this.modalController.dismiss();
  }

  onAddAnotherStep() {
    this.updatedEditList.push({
      name: '',
      deletable: true,
    });
  }

  deleteRow(item: TEditItem) {
    this.updatedEditList = this.updatedEditList.filter((itm) => itm !== item);
  }

  onEdit() {
    this.action = 'EDIT';
    this.initialize();
  }

  onSave() {
    switch (this.action) {
      case 'EDIT':
        const updatedEditList = this.updatedEditList.filter((l) => l.name !== '');
        this.modalController.dismiss({ updatedEditList });
        break;
    }
  }
}
